(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('InvoiceMinDTO', InvoiceMinDTO);

    InvoiceMinDTO.$inject = ['$resource', 'DateUtils'];

    function InvoiceMinDTO ($resource, DateUtils) {
        var resourceUrl =  'api/invoiceMinDTO/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.invoiceDate = DateUtils.convertLocalDateFromServer(data.invoiceDate);
                    }
                    return data;
                }
            }
        });
    }
})();
